import { useEffect, useState } from "react";
import { registerServiceWorker } from "@/lib/swClient";
import { onProtocolOutdated } from "@/lib/syncEngine";

export default function UpdateBanner() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    registerServiceWorker(() => setAvailable(true));
  }, []);

  useEffect(() => onProtocolOutdated(() => setAvailable(true)), []);

  if (!available) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 rounded-full bg-slate-900 px-4 py-2 text-sm text-white shadow-lg dark:bg-slate-100 dark:text-slate-900"
    >
      Доступна новая версия.{" "}
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="ml-1 font-semibold underline underline-offset-2"
      >
        Обновить
      </button>
    </div>
  );
}
